import { setUser } from "@store/authSlice";
import { persistor } from "@store/store";
import { AuthService } from "@service/auth.service";
import { NotificationService } from "@service/notification.service";
import { Dispatch } from "redux";

const authService = AuthService.instance;
const notificationService = NotificationService.instance;

export class SignOutService {
  public static instance = new SignOutService();

  private constructor() {}

  async signOut(dispatch: Dispatch): Promise<void> {
    await notificationService.unsubscribeAll();
    await authService.signOut();
    window.location.href = "/";
    dispatch(setUser(null));
    await persistor.purge();
    localStorage.clear();
  }
}
